export const UNIFIED_MSR = 'UNIFIED_MSR';

export const excludedUserLevels = ['MERCHANT', 'AGGREGATOR'];
